export default {
  list: {
    subtitle: 'International logistics informatization, no islands should exist',
    searchPlaceholder: 'Search API name, press Enter to search',
    noResults: 'No related API interfaces found',
    noResultsHint: 'Please try adjusting search keywords or filter conditions',
  },
  card: {
    viewDocs: 'View Docs',
    statusAvailable: 'Available',
    statusUnavailable: 'Unavailable',
  },
  categories: {
    systemSettings: 'System Settings',
    orderCenter: 'Order Center',
    customerCenter: 'Customer Center',
    superRate: 'Super Rate',
    vasProcessor: 'VAS Interface Processor'
  }
}

